import { z } from 'zod';
export const zBenchmarkGridType = z.enum(['rep', 'kpi']);
/**
 * Thrown when a KPI grid create/edit would map a metric that is already used on
 * another KPI grid in the same team (the one-metric-per-team rule, enforced in
 * the router rather than by a DB constraint). Surfaced inline in the drawer.
 */
export const KPI_METRIC_ALREADY_ASSIGNED_ERROR = 'KPI_METRIC_ALREADY_ASSIGNED_ERROR';
/**
 * Thrown when a KPI grid create/edit submits a metric that is not eligible for
 * KPI use (not numeric, not collectable, soft-deleted, or an intensity/sets/reps
 * type). The picker only offers eligible metrics, so this is a server-side
 * defense against stale or crafted requests; already-assigned metrics are
 * grandfathered on edit and never trip it.
 */
export const KPI_METRIC_INELIGIBLE_ERROR = 'KPI_METRIC_INELIGIBLE_ERROR';
export const zBenchmarkUpdateType = z.enum(['none', 'tested']);
export const zOneRepMaxFormula = z.enum([
    'brzycki',
    'epley',
    'lander',
    'lombardi',
    'mayhew',
    'oconner',
    'wathan',
]);
export const DEFAULT_ONE_REP_MAX_FORMULA = 'brzycki';
const BaseBenchmarkGrid = z.object({
    id: z.uuid(),
    name: z.string(),
    type: zBenchmarkGridType,
    repCount: z.number(),
    updateType: zBenchmarkUpdateType,
    isDefault: z.boolean(),
    coreExercises: z.array(z.object({
        id: z.uuid(),
        libraryExerciseId: z.uuid(),
        sortOrder: z.number(),
    })),
});
//# sourceMappingURL=benchmarks.js.map